import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useHideReviewsUIByFacilityId(): { facilityIds: string[] } {
  return useCbhFlag(CbhFeatureFlag.HIDE_REVIEWS_UI_BY_FACILITY_ID, {
    defaultValue: {
      facilityIds: [],
    },
  });
}
